import { AlertTriangle, Shield } from 'lucide-react';

export default function Disclaimer({ variant = 'full' }) {
  const c = {
    mini: 'Livon erbjuder inte medicinsk vård, psykoterapi eller diagnos. Vid psykisk ohälsa rekommenderas kontakt med legitimerad vårdgivare.',
    important: 'Viktig information',
    description: 'Livon är ett verktyg för självreflektion, personlig utveckling och välmående. Appen hjälper dig att få koll på din vardag, sätta mål och utvecklas genom strukturerade verktyg.',
    noMedical: 'Appen erbjuder inte medicinsk vård, psykoterapi eller diagnos.',
    contact: 'Vid psykisk ohälsa eller om du mår mycket dåligt, kontakta legitimerad vårdgivare, vårdcentral eller ring 112 vid akut kris.',
    gdpr: 'GDPR & Dataskydd',
    gdprText: 'Din data lagras säkert och delas aldrig med tredje part. Du kan när som helst ladda ner eller radera all din data via Inställningar.'
  };

  if (variant === 'mini') {
    return (
      <p className="text-xs text-muted-foreground text-center max-w-md mx-auto">
        {c.mini}
      </p>
    );
  }

  return (
    <div className="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-xl p-5 space-y-4">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div className="space-y-3">
          <p className="text-sm font-semibold text-foreground">
            {c.important}
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {c.description}
          </p>
          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-3">
            <p className="text-sm text-amber-800 dark:text-amber-200 font-medium">
              {c.noMedical}
            </p>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {c.contact}
          </p>
        </div>
      </div>
      
      <div className="flex items-start gap-3 pt-2 border-t border-slate-200 dark:border-slate-700">
        <Shield className="w-5 h-5 text-primary shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-foreground">
            {c.gdpr}
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {c.gdprText}
          </p>
        </div>
      </div>
    </div>
  );
}
